function index (vm) {
  const {convertColorByRule} = require('_lib/dark-mode-ruler')
  const theme_element_list = []
  let current_theme = vm.prototype.$hb_theme = 'light'
  initMediaQuery()
  
  vm.directive('theme', {
    bind: themeColorCallBack,
    update: themeColorCallBack
  })
  function initMediaQuery () {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    if (!mediaQuery || !mediaQuery.addEventListener) return
    current_theme = mediaQuery.matches ? 'dark' : 'light'
    vm.prototype.$hb_theme = current_theme
    mediaQuery.addEventListener('change', (e) => {
      current_theme = mediaQuery.matches ? 'dark' : 'light'
      vm.prototype.$hb_theme = current_theme
      theme_element_list.forEach((item) => {
        if (item.el) {
          changeTheme(item)
        }
      })
    })
  }
  function themeColorCallBack (el, binding, vnode) {
    let temp
    if (!(temp = theme_element_list.find(_=>_.el == el))) {
      temp = {
        el,
        value: {},
        theme: {}
      }
      updateValue(temp, binding)
      theme_element_list.push(temp)
    } else {
      updateValue(temp, binding)
    }
    changeTheme(temp)
  }
  function updateValue (temp, binding) {
    if (binding.modifiers.self) {
      Object.entries(binding.value).forEach(([_key, _value]) => {
        temp.theme[_key] = _value
      })
    } else if (binding.modifiers.light) {
      temp.theme['light'] = binding.value
    } else if (binding.modifiers.dark) {
      temp.theme['dark'] = binding.value
    } else {
      temp.value = binding.value
    }
  }
  function changeTheme ({el, value, theme}) {
    let style = ''
    Object.entries(value).forEach(([key, value]) => {
      try {
        if (String(value).match(/rgb|hsl|hsv|#/)) {
          if (current_theme == 'dark') {
            let temp = value.match(/hs.\(.*?\)|#[a-zA-Z0-9]*|rgb.{0,1}\(.*?\)/g)
            if (temp) {
              temp.forEach(color => {
                value = value.replace(color, convertColorByRule(color))
              })
            }
          }
        }
      } catch (err) {
        console.log('[err_value]:', value);
        console.log('[err]:', err);
      }
      
      style += `${key}: ${value};`
    })
    Object.entries(theme).forEach(([theme, obj]) => {
      if (theme == current_theme) {
        Object.entries(obj).forEach(([key, value]) => {
          style += `${key}: ${value};`
        })
      }
    })
    el.setAttribute('style', style)
  }
}

export default {
  install (Vue) {
    index(Vue)
  }
}